// import React, { useMemo, useRef, useState } from 'react';
// import { useFrame } from '@react-three/fiber';
// import { useGLTF, OrbitControls } from '@react-three/drei';
// import { Perf } from 'r3f-perf';
// import { InstancedRigidBodies, CylinderCollider, CuboidCollider, RigidBody, Physics } from '@react-three/rapier';
// import * as THREE from 'three';

// function GLTFModel({ url }) {
//     const { scene } = useGLTF(url);
//     return <primitive object={scene} />;
// }

// export default function Experience({ modelUrl }) {
//     const [hitSound] = useState(() => new Audio('./hit.mp3'));
//     const twister = useRef();
//     const cube = useRef();

//     useFrame((state) => {
//         const time = state.clock.getElapsedTime();

//         const eulerRotation = new THREE.Euler(0, time * 3, 0);
//         const quaternionRotation = new THREE.Quaternion();
//         quaternionRotation.setFromEuler(eulerRotation);
//         // twister.current.setNextKinematicRotation(quaternionRotation);

//         const angle = time * 0.5;
//         const x = Math.cos(angle) * 2;
//         const z = Math.sin(angle) * 2;
//         // twister.current.setNextKinematicTranslation({ x: x, y: -0.8, z: z });
//     });

//     const cubeJump = () => {
//         const mass = cube.current.mass();

//         cube.current.applyImpulse({ x: 0, y: 5 * mass, z: 0 });
//         cube.current.applyTorqueImpulse({ x: Math.random() - 0.5, y: Math.random() - 0.5, z: Math.random() - 0.5 });
//     };

//     const collisionEnter = () => {
//         console.log('collision!');
//         // hitSound.currentTime = 0
//         // hitSound.volume = Math.random()
//         // hitSound.play()
//     };

//     const cubesCount = 100;
//     const instances = useMemo(() => {
//         const instances = [];

//         for (let i = 0; i < cubesCount; i++) {
//             instances.push({
//                 key: 'instance_' + i,
//                 position: [
//                     (Math.random() - 0.5) * 8,
//                     6 + i * 0.2,
//                     (Math.random() - 0.5) * 8,
//                 ],
//                 rotation: [Math.random(), Math.random(), Math.random()],
//             });
//         }

//         return instances;
//     }, []);

//     return (
//         <>
//             {/* <Perf position="top-left" /> */}
//             <OrbitControls makeDefault />
//             <directionalLight castShadow position={[1, 2, 3]} intensity={4.5} />
//             {/* <ambientLight intensity={1.5} /> */}
//             <Physics debug={true} gravity={[0, -9.08, 0]}>
//                 {/* <RigidBody colliders="ball" position={[-1.5, 2, 0]}>
//                     <mesh castShadow>
//                         <sphereGeometry />
//                         <meshStandardMaterial color="orange" />
//                     </mesh>
//                 </RigidBody>
            
//                 <RigidBody type="fixed" restitution={0} friction={0.7}>
//                     <mesh receiveShadow position-y={-1.25}>
//                         <boxGeometry args={[10, 0.5, 10]} />
//                         <meshStandardMaterial color="greenyellow" />
//                     </mesh>
//                 </RigidBody>
//                 <RigidBody ref={twister} position={[0, -0.8, 0]} friction={0} type="kinematicPosition">
//                     <mesh castShadow scale={[0.4, 0.4, 3]}>
//                         <boxGeometry />
//                         <meshStandardMaterial color="red" />
//                     </mesh>
//                 </RigidBody> */}
                
                
//             </Physics>
//             {modelUrl && <GLTFModel url={modelUrl} />}
//         </>
//     );
// }

import React, { useEffect, useRef } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import { useGLTF, OrbitControls, Center, Bounds } from '@react-three/drei';
import * as THREE from 'three';

function GLTFModel({ url }) {
    const { scene } = useGLTF(url);
    
    useEffect(() => {
        // Compute bounding box to auto-scale model
        const box = new THREE.Box3().setFromObject(scene);
        const size = new THREE.Vector3();
        box.getSize(size);
        
        const maxDim = Math.max(size.x, size.y, size.z);
        const targetSize = 3; // desired world units
        const scale = targetSize / maxDim;
        
        scene.scale.setScalar(scale);
        
        // Center the model at origin
        box.setFromObject(scene);
        const center = new THREE.Vector3();
        box.getCenter(center);
        scene.position.sub(center);
        
        scene.traverse((child) => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });
    }, [scene, url]);
    
    return <primitive object={scene} />;
}

export default function Experience({ modelUrl }) {
    const orbitRef = useRef();

    return (
        <>
            <OrbitControls
                ref={orbitRef}
                makeDefault
                enableDamping
                dampingFactor={0.05}
                minDistance={1}
                maxDistance={20}
                autoRotate
                autoRotateSpeed={1.2}
                minPolarAngle={0.3}
                maxPolarAngle={Math.PI / 1.8}
            />

            {/* Key light */}
            <directionalLight
                castShadow
                position={[4, 6, 4]}
                intensity={3}
                shadow-mapSize={[2048, 2048]}
            />
            {/* Fill light */}
            <directionalLight position={[-4, 2, -4]} intensity={1.2} color="#b0c4ff" />
            {/* Ambient */}
            <ambientLight intensity={0.8} />
            {/* Rim light */}
            <pointLight position={[0, 6, -4]} intensity={2} color="#ffffff" />

            {modelUrl && <GLTFModel url={modelUrl} />}
        </>
    );
}
